import React from 'react'
import './checkout.css'

const Checkout = () => {
  return (
    <div className='item-checkout'>
      <p>Your'e Order has been placed! <br />Happy Shopping!</p>
      
    </div>
  )
}

export default Checkout